
import * as React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { FormattedDateTimeRange, FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
function TypographyElipsis({ children, sx, ...otherProps }) {
  return (
    <Typography
      sx={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',

        textOverflow: 'ellipsis',
        ...sx
      }}
      {...otherProps}>
      {children}
    </Typography>
  );
}

TypographyElipsis.propTypes = {
  children: PropTypes.any,
  sx: PropTypes.any
};

export default function RservationCard({ userReservation, onReserve, onCancelReservation }) {
  return (
    <Card>
      <CardHeader
        title={userReservation.name}
        titleTypographyProps={{ align: 'center' }}
        sx={{
          '& .MuiCardHeader-content': {
            width: '100%',
            '& span': {
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }
          },
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? theme.palette.grey[200]
              : theme.palette.grey[700],
        }}
      />
      <CardContent>
        <Box sx={{ fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <TypographyElipsis sx={{ fontWeight: 'bold' }}>
            <FormattedDateTimeRange from={new Date(userReservation.reservationTimeFrom)} to={new Date(userReservation.reservationTimeTo)} dateStyle='short' timeStyle='short' />
          </TypographyElipsis>
        </Box>
        <TypographyElipsis color="text.primary" >
          {userReservation.location}
        </TypographyElipsis>
        <TypographyElipsis color="text.primary" >
          <FormattedMessage id='reservationCard.msg.freeSpots' defaultMessage='{number} free spots' values={{ number: userReservation.availableSpots - userReservation.reservedSpots }} />
        </TypographyElipsis>
      </CardContent>
      <CardActions>
        {
          !userReservation.userReserved ?
            <Button disabled={userReservation.userHasReservation || (userReservation.availableSpots - userReservation.reservedSpots) === 0} fullWidth variant='contained' value={userReservation.id} onClick={onReserve}>
              <FormattedMessage id='reservationCard.button.reserve' defaultMessage='Reserve' />
            </Button> :
            <Button fullWidth variant='contained' color='error' value={userReservation.userReserved} onClick={onCancelReservation}>
              <FormattedMessage id='reservationCard.button.cancelReservation' defaultMessage='Cancel Reservation' />
            </Button>
        }
      </CardActions>
    </Card >

  );
}

RservationCard.propTypes = {
  userReservation: PropTypes.any,
  onReserve: PropTypes.func,
  onCancelReservation: PropTypes.func
};